export default "__VITE_ASSET__BrzM_kZr__"